interface HiringType {
    id: number;
    name: string;
}

export let defaultHiringTypes:HiringType[] = [
    {id: 1, name: "100% nómina"},
    {id: 2, name: "Contractor"},
]